import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => {
  return {
    container: {
      fontWeight: 500,
    },
  };
});
